// extracted by mini-css-extract-plugin
module.exports = {"board":"board__2w-lp"};